/*eslint-disable*/
export const messages = {
  "Cancel": "Abbrechen",
  "Change theme": "Thema ändern",
  "Clear chat": "Chat löschen",
  "Clear chat history": "Chat-Verlauf löschen",
  "Connecting...": "Verbindung wird hergestellt...",
  "Continue": "Fortfahren",
  "Decrease font size": "Schriftgröße verkleinern",
  "Disclaimer": "Haftungsausschluss",
  "Enter your message...": "Geben Sie Ihre Nachricht ein...",
  "Type your message...": "Geben Sie Ihre Nachricht ein...",
  "Error": "Fehler",
  "Font size": "Schriftgröße",
  "Increase font size": "Schriftgröße vergrößern",
  "Language": "Sprache",
  "MJ Lab": "MJ Labor",
  "Reset font size": "Schriftgröße zurücksetzen",
  "Respond time: {time}s": "Antwortzeit: {time}s",
  "Response time:": "Antwortzeit:",
  "Send": "Senden",
  "Settings": "Einstellungen",
  "Support the project": "Projekt unterstützen",
  "System": "System",
  "Theme": "Thema",
  "Thinking...": "Denke nach...",
  "Toggle theme": "Thema umschalten",
  "Welcome to Kai by MJ": "Willkommen bei Kai von MJ",
  "You asked:": "Sie fragten:",
  
  // Headers
  "Labor Law Expert": "Arbeitsrechtsexperte",
  "by MJ": "von MJ",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Hallo, ich bin {{name}}, ein von MJ entwickelter KI-Assistent.",
  "I am expert in labor laws and regulations for Saudi Arabia.": "Ich bin Experte für die Arbeitsgesetze und -vorschriften in Saudi-Arabien.",
  "Ask me a question, and I will gladly answer you.": "Stellen Sie mir eine Frage, und ich werde Ihnen gerne antworten.",
  "Do not share confidential data.": "Teilen Sie keine vertraulichen Daten mit.",
  "I am powered using": "Ich werde betrieben mit",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Haftungsausschluss:** {{name}} ist ein experimenteller KI-Assistent, der auf Grundlage von Daten aus saudischen Arbeitsgesetzen und -vorschriften antwortet und Annahmen oder Ungenauigkeiten vermeidet. Ich übernehme keine Verantwortung für sein Verhalten oder die Richtigkeit seiner Antworten.",
  
  // Frameworks - keeping these for backward compatibility
  "Automatic detection": "Automatische Erkennung",
  "Labor Law": "Arbeitsrecht",
  "Saudization": "Saudisierung",
  "Contracts": "Verträge",
  "Termination": "Kündigung",
  "Wages & Benefits": "Löhne & Leistungen",
  "Leave Policies": "Urlaubsrichtlinien",
  "Workplace Safety": "Arbeitsplatzsicherheit",
  
  // Models
  "Claude by Anthropic": "Claude von Anthropic",
  "DeepSeek by Groq": "DeepSeek von Groq",
  "MJ Lab Mode": "MJ-Labor-Modus",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} Zeichen übrig",
  "{{remainingChars}} characters left": "{{remainingChars}} Zeichen übrig",
  
  // Error messages
  "An error occurred": "Ein Fehler ist aufgetreten",
  "Failed to change language": "Sprachänderung fehlgeschlagen",
  "Please try again": "Bitte versuchen Sie es erneut",
  "Connection lost": "Verbindung verloren",
  "Reconnecting...": "Verbindung wird wiederhergestellt...",
  "Nothing to clear": "Nichts zu löschen",
  "All messages cleared": "Alle Nachrichten gelöscht",
  "All data cleared": "Alle Daten gelöscht",
  "Storage limit reached": "Speicherlimit erreicht",
  "Some older messages were removed to save space.": "Einige ältere Nachrichten wurden entfernt, um Speicherplatz zu sparen.",
  
  // Additional keys
  "Font Size": "Schriftgröße",
  "Language changed to {locale}": "Sprache wurde auf {locale} geändert",
  "Select language": "Sprache auswählen",
  "Support": "Unterstützung",
  
  // Brand names (do not translate)
  "Leen": "Leen",
  
  // Message actions
  "Message copied to clipboard": "Nachricht in die Zwischenablage kopiert",
  "Read": "Lesen",
  "Summarize": "Zusammenfassen",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Nachrichtenvorschläge",
  "Select a question to quickly start a conversation about Saudi labor laws.": "Wählen Sie eine Frage, um schnell ein Gespräch über saudische Arbeitsgesetze zu beginnen.",
  "What are the key employee rights under Saudi labor law? Can you provide a simple overview?": "Was sind die wichtigsten Arbeitnehmerrechte nach saudischem Arbeitsrecht? Können Sie einen einfachen Überblick geben?",
  "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?": "Welche Verpflichtungen haben Arbeitgeber in Bezug auf Arbeitszeiten, Überstunden und Urlaub in Saudi-Arabien?",
  "How does Saudi labor law handle termination of employment and end-of-service benefits?": "Wie regelt das saudische Arbeitsrecht die Kündigung des Arbeitsverhältnisses und Abfindungen?",
  
  // Audio Player Dialog
  "AI Summary": "KI-Zusammenfassung",
  "Listen to the summarized response using our AI Service.": "Hören Sie sich die zusammengefasste Antwort mit unserem KI-Service an.",
  "Generating summary...": "Zusammenfassung wird erstellt...",
  "Preparing audio...": "Audio wird vorbereitet...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Textverarbeitung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "Failed to auto-play audio. Click play to try again.": "Automatische Audiowiedergabe fehlgeschlagen. Klicken Sie auf Play, um es erneut zu versuchen.",
  "Failed to load audio. Please try again.": "Audio konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
  "Audio playback was aborted.": "Audiowiedergabe wurde abgebrochen.",
  "Network error occurred while loading audio.": "Netzwerkfehler beim Laden des Audios aufgetreten.",
  "Audio decoding failed.": "Audio-Dekodierung fehlgeschlagen.",
  "Audio format not supported.": "Audioformat wird nicht unterstützt.",
  "Failed to setup audio playback": "Einrichtung der Audiowiedergabe fehlgeschlagen",
  "Failed to generate speech": "Sprachgenerierung fehlgeschlagen",
  "Failed to generate audio. Please try again.": "Generierung von Audio fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "Failed to play audio. Please try again.": "Wiedergabe von Audio fehlgeschlagen. Bitte versuchen Sie es erneut.",
  
  // Update Notifications
  "update.updateAvailable": "Update verfügbar",
  "update.newVersionAvailable": "Neue Version {{version}} verfügbar",
  "update.refreshToApply": "Aktualisieren Sie, um die neuesten Funktionen und Verbesserungen anzuwenden",
  "update.later": "Später",
  "update.updateNow": "Jetzt aktualisieren",
  
  // CSAT Feedback
  "We Value Your Feedback": "Wir schätzen Ihr Feedback",
  "Give Feedback": "Feedback geben",
  "How would you rate your experience?": "Wie würden Sie Ihre Erfahrung bewerten?",
  "Very Dissatisfied": "Sehr unzufrieden",
  "Dissatisfied": "Unzufrieden",
  "Neutral": "Neutral",
  "Satisfied": "Zufrieden",
  "Very Satisfied": "Sehr zufrieden",
  "Select a rating": "Wählen Sie eine Bewertung",
  "Comments or Bug Report": "Kommentare oder Fehlerbericht",
  "Please share your thoughts or report any issues...": "Bitte teilen Sie Ihre Gedanken mit oder melden Sie Probleme...",
  "Contact Number": "Kontaktnummer",
  "Feedback Type": "Feedback-Typ",
  "Select a feedback type": "Wählen Sie einen Feedback-Typ",
  "Loading...": "Wird geladen...",
  "No feedback types available": "Keine Feedback-Typen verfügbar", 
  "(Optional)": "(Optional)",
  "Feedback Submitted": "Feedback eingereicht",
  "Thank you for your feedback!": "Vielen Dank für Ihr Feedback!",
  "Rating Required": "Bewertung erforderlich",
  "Please select a rating before submitting.": "Bitte wählen Sie vor dem Absenden eine Bewertung aus.",
  "Submit Feedback": "Feedback senden",
  "Submitting...": "Wird gesendet...",
  "General": "Allgemein",
  "Bug": "Fehler",
  "Idea": "Idee",
  
  // Feedback Dashboard
  "Feedback Dashboard": "Feedback-Dashboard",
  "Total Feedbacks": "Gesamtzahl der Feedbacks",
  "All-time submissions": "Alle Einreichungen",
  "Average Rating": "Durchschnittliche Bewertung",
  "Out of 5 stars": "Von 5 Sternen",
  "Feedback with Comments": "Feedback mit Kommentaren",
  "Detailed feedback": "Detailliertes Feedback",
  "Rating Distribution": "Bewertungsverteilung",
  "Breakdown of user satisfaction": "Aufschlüsselung der Benutzerzufriedenheit",
  "Rating Percentage": "Bewertungsprozentsatz",
  "Proportion of each rating": "Anteil jeder Bewertung",
  "Responses": "Antworten",
  "All Feedback": "Gesamtes Feedback",
  "Detailed view of user submissions": "Detaillierte Ansicht der Benutzereinreichungen",
  "ID": "ID",
  "Rating": "Bewertung",
  "Comment": "Kommentar",
  "Contact": "Kontakt",
  "Date": "Datum",
  "Page": "Seite",
  "No feedback data available": "Keine Feedback-Daten verfügbar",
  "No comment": "Kein Kommentar",
  "Not provided": "Nicht angegeben",
  "Not available": "Nicht verfügbar",
  
  // Authentication
  "Login": "Anmelden",
  "Register": "Registrieren",
  "Username": "Benutzername",
  "Password": "Passwort",
  "Confirm Password": "Passwort bestätigen",
  "Email": "E-Mail",
  "Full Name": "Vollständiger Name",
  "Don't have an account?": "Haben Sie kein Konto?",
  "Already have an account?": "Haben Sie bereits ein Konto?",
  "Login to continue": "Melden Sie sich an, um fortzufahren",
  "Create an account": "Konto erstellen",
  "Passwords must match": "Passwörter müssen übereinstimmen",
  "Invalid email": "Ungültige E-Mail",
  "Required": "Erforderlich",
  "Unauthorized": "Nicht autorisiert",
  "You don't have permission to access this page.": "Sie haben keine Berechtigung, auf diese Seite zuzugreifen."
};